import React from 'react';
import axios from 'axios';
import { Eye, X } from 'lucide-react';
import { useAuth } from '../App';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ViewAsBanner() {
  const { user } = useAuth();
  if (!user?.viewing_as) return null;
  const exit = async () => {
    await axios.post(`${API}/api/view-as/exit`, {}, { withCredentials: true }).catch(() => {});
    window.location.href = '/admin/clients';
  };
  return (
    <div className="sticky top-0 z-[60] bg-[#F97316] text-white text-sm font-medium px-4 py-2 flex items-center justify-center gap-3" data-testid="view-as-banner">
      <Eye size={16} />
      <span>Viewing as <strong>{user.name || user.email}</strong> · read-only</span>
      <button onClick={exit} data-testid="view-as-exit" className="inline-flex items-center gap-1 bg-white text-[#C2410C] font-bold text-xs px-3 py-1 rounded-full hover:bg-orange-50 transition-colors">
        <X size={12} /> Exit
      </button>
    </div>
  );
}
